<template>
  <div class="pricing-page">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container has-text-centered -adjust-content-up">
          <img
            src="../assets/img/illustrations/04.png"
            class="-image has-margin-bottom-20"
          />
          <h1 class="title has-margin-bottom-40">We're working on it.</h1>
          <p class="subtitle">
            Our API Service isn't publicly available just yet. In the meantime,
            you can <router-link to="/contact">contact us</router-link>, join
            our newsletter, or apply for our beta program as we prepare to roll
            out the API service.
          </p>
          <router-link to="/contact">
            <b-button type="is-primary" icon-left="email">
              Contact Us
            </b-button>
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "pricingPage"
};
</script>

<style scoped lang="scss">
.-image {
  max-height: 256px;
  width: auto;
}

@media only screen and (max-width: 600px) {
  .-image {
    max-height: 192px;
    width: auto;
  }
}

.-adjust-content-up {
  margin-top: -120px;
}
</style>
